// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.driver-active,
.driver-active *,
.driver-active #modal-root .portal-child [role="dialog"] {
  pointer-events: none;
}

.driver-active .driver-overlay {
  pointer-events: none;
  overflow: hidden;
}

.driver-active .driver-active-element,
.driver-active .driver-active-element *,
.driver-popover,
.driver-popover * {
  pointer-events: auto;
}

.driver-active:not(:has(.driver-no-interaction)):has(.driver-active-element [class*="FieldSelect"])
  [aria-modal="true"]
  * {
  pointer-events: auto;
}

#webpack-dev-server-client-overlay,
#react-refresh-overlay {
  pointer-events: auto;
}

.driver-active .portal-child:has(.driver-active-element) [class*="Portal__InvisiBox"],
.driver-active .portal-child:has([aria-controls="driver-popover-content"]) [class*="Portal__InvisiBox"] {
  z-index: 1400 !important;
}

.driver-popover {
  padding: 0;
  background-color: transparent;
  box-shadow: none;
  opacity: 0;
}

.driver-popover-close-btn,
.driver-popover-title,
.driver-popover-description,
.driver-popover-footer {
  display: none !important;
}

.driver-overlay path {
  transition: all 100ms;
}

.driver-full-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000000000;
  background: rgba(0, 0, 0, 0.4);
  overflow: hidden;
}

.driver-active:has(.driver-overlay[style*="visibility: visible"]) .driver-full-overlay {
  background: transparent;
}

/* Popover styles */
.driver-popover {
  all: unset;
  box-sizing: border-box;
  margin: 0;
  width: 300px;
  z-index: 1000000000;
  position: fixed;
  top: 0;
  right: 0;
  pointer-events: auto;
}

.driver-popover * {
  box-sizing: border-box;
}

.driver-no-interaction,
.driver-no-interaction * {
  pointer-events: none !important;
}

.driver-popover-arrow {
  content: "";
  position: absolute;
  border: 5px solid #fff;
}

.driver-popover-arrow-side-over {
  display: none;
}

/** Popover Arrow Sides **/
.driver-popover-arrow-side-left {
  left: 100%;
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-top-color: transparent;
}

.driver-popover-arrow-side-right {
  right: 100%;
  border-left-color: transparent;
  border-bottom-color: transparent;
  border-top-color: transparent;
}

.driver-popover-arrow-side-top {
  top: 100%;
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-left-color: transparent;
}

.driver-popover-arrow-side-bottom {
  bottom: 100%;
  border-left-color: transparent;
  border-top-color: transparent;
  border-right-color: transparent;
}

.driver-popover-arrow-side-center {
  display: none;
}

/* Left/Start + Right/Start */
.driver-popover-arrow-side-left.driver-popover-arrow-align-start,
.driver-popover-arrow-side-right.driver-popover-arrow-align-start {
  top: 15px;
}

/* Top/Start + Bottom/Start */
.driver-popover-arrow-side-top.driver-popover-arrow-align-start,
.driver-popover-arrow-side-bottom.driver-popover-arrow-align-start {
  left: 15px;
}

/* End/Left + End/Right */
.driver-popover-arrow-align-end.driver-popover-arrow-side-left,
.driver-popover-arrow-align-end.driver-popover-arrow-side-right {
  bottom: 15px;
}

/* Top/End + Bottom/End */
.driver-popover-arrow-side-top.driver-popover-arrow-align-end,
.driver-popover-arrow-side-bottom.driver-popover-arrow-align-end {
  right: 15px;
}

/* Left/Center + Right/Center */
.driver-popover-arrow-side-left.driver-popover-arrow-align-center,
.driver-popover-arrow-side-right.driver-popover-arrow-align-center {
  top: 50%;
  margin-top: -5px;
}

/* Top/Center + Bottom/Center */
.driver-popover-arrow-side-top.driver-popover-arrow-align-center,
.driver-popover-arrow-side-bottom.driver-popover-arrow-align-center {
  left: 50%;
  margin-left: -5px;
}
`, "",{"version":3,"sources":["webpack://./src/providers/TourProvider/driver.css"],"names":[],"mappings":"AAAA;;;EAGE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;;;EAGE,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,6BAA6B;EAC7B,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;;;EAIE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,UAAU;EACV,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,MAAM;EACN,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,UAAU;EACV,+BAA+B;EAC/B,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA,6BAA6B;AAC7B;;EAEE,SAAS;AACX;;AAEA,6BAA6B;AAC7B;;EAEE,UAAU;AACZ;;AAEA,yBAAyB;AACzB;;EAEE,YAAY;AACd;;AAEA,yBAAyB;AACzB;;EAEE,WAAW;AACb;;AAEA,+BAA+B;AAC/B;;EAEE,QAAQ;EACR,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;;EAEE,SAAS;EACT,iBAAiB;AACnB","sourcesContent":[".driver-active,\n.driver-active *,\n.driver-active #modal-root .portal-child [role=\"dialog\"] {\n  pointer-events: none;\n}\n\n.driver-active .driver-overlay {\n  pointer-events: none;\n  overflow: hidden;\n}\n\n.driver-active .driver-active-element,\n.driver-active .driver-active-element *,\n.driver-popover,\n.driver-popover * {\n  pointer-events: auto;\n}\n\n.driver-active:not(:has(.driver-no-interaction)):has(.driver-active-element [class*=\"FieldSelect\"])\n  [aria-modal=\"true\"]\n  * {\n  pointer-events: auto;\n}\n\n#webpack-dev-server-client-overlay,\n#react-refresh-overlay {\n  pointer-events: auto;\n}\n\n.driver-active .portal-child:has(.driver-active-element) [class*=\"Portal__InvisiBox\"],\n.driver-active .portal-child:has([aria-controls=\"driver-popover-content\"]) [class*=\"Portal__InvisiBox\"] {\n  z-index: 1400 !important;\n}\n\n.driver-popover {\n  padding: 0;\n  background-color: transparent;\n  box-shadow: none;\n  opacity: 0;\n}\n\n.driver-popover-close-btn,\n.driver-popover-title,\n.driver-popover-description,\n.driver-popover-footer {\n  display: none !important;\n}\n\n.driver-overlay path {\n  transition: all 100ms;\n}\n\n.driver-full-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 10000000000;\n  background: rgba(0, 0, 0, 0.4);\n  overflow: hidden;\n}\n\n.driver-active:has(.driver-overlay[style*=\"visibility: visible\"]) .driver-full-overlay {\n  background: transparent;\n}\n\n/* Popover styles */\n.driver-popover {\n  all: unset;\n  box-sizing: border-box;\n  margin: 0;\n  width: 300px;\n  z-index: 1000000000;\n  position: fixed;\n  top: 0;\n  right: 0;\n  pointer-events: auto;\n}\n\n.driver-popover * {\n  box-sizing: border-box;\n}\n\n.driver-no-interaction,\n.driver-no-interaction * {\n  pointer-events: none !important;\n}\n\n.driver-popover-arrow {\n  content: \"\";\n  position: absolute;\n  border: 5px solid #fff;\n}\n\n.driver-popover-arrow-side-over {\n  display: none;\n}\n\n/** Popover Arrow Sides **/\n.driver-popover-arrow-side-left {\n  left: 100%;\n  border-right-color: transparent;\n  border-bottom-color: transparent;\n  border-top-color: transparent;\n}\n\n.driver-popover-arrow-side-right {\n  right: 100%;\n  border-left-color: transparent;\n  border-bottom-color: transparent;\n  border-top-color: transparent;\n}\n\n.driver-popover-arrow-side-top {\n  top: 100%;\n  border-right-color: transparent;\n  border-bottom-color: transparent;\n  border-left-color: transparent;\n}\n\n.driver-popover-arrow-side-bottom {\n  bottom: 100%;\n  border-left-color: transparent;\n  border-top-color: transparent;\n  border-right-color: transparent;\n}\n\n.driver-popover-arrow-side-center {\n  display: none;\n}\n\n/* Left/Start + Right/Start */\n.driver-popover-arrow-side-left.driver-popover-arrow-align-start,\n.driver-popover-arrow-side-right.driver-popover-arrow-align-start {\n  top: 15px;\n}\n\n/* Top/Start + Bottom/Start */\n.driver-popover-arrow-side-top.driver-popover-arrow-align-start,\n.driver-popover-arrow-side-bottom.driver-popover-arrow-align-start {\n  left: 15px;\n}\n\n/* End/Left + End/Right */\n.driver-popover-arrow-align-end.driver-popover-arrow-side-left,\n.driver-popover-arrow-align-end.driver-popover-arrow-side-right {\n  bottom: 15px;\n}\n\n/* Top/End + Bottom/End */\n.driver-popover-arrow-side-top.driver-popover-arrow-align-end,\n.driver-popover-arrow-side-bottom.driver-popover-arrow-align-end {\n  right: 15px;\n}\n\n/* Left/Center + Right/Center */\n.driver-popover-arrow-side-left.driver-popover-arrow-align-center,\n.driver-popover-arrow-side-right.driver-popover-arrow-align-center {\n  top: 50%;\n  margin-top: -5px;\n}\n\n/* Top/Center + Bottom/Center */\n.driver-popover-arrow-side-top.driver-popover-arrow-align-center,\n.driver-popover-arrow-side-bottom.driver-popover-arrow-align-center {\n  left: 50%;\n  margin-left: -5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
